import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../OEMConfig';
import store from '../app/store';
import { loginSuccess } from '../features/common/authSlice';
import authStorage from '../utils/authStorage';
import axios from '../utils/axios';

function LoginByRoot() {
  const navigate = useNavigate();
  const origin = config().root_host;

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== origin) return;

      if (event.data === 'ping') return;

      let payload;
      try {
        payload = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      } catch (err) {
        console.error('Failed to parse payload:', err);
        return;
      }

      if (!payload?.token) {
        console.error('Invalid payload');
        return;
      }

      authStorage.set('token', payload?.token);
      authStorage.setJSON('roles', payload?.roles);
      authStorage.set('is_gsc_optional', payload?.is_gsc_optional);
      authStorage.set('is_super_login', payload?.is_super_login);

      if (payload?.service_access) {
        authStorage.setJSON('serviceAccess', payload?.service_access);
      }

      axios.defaults.headers.common['Authorization'] = `Bearer ${payload?.token}`;

      const { token, service_access, ...userInfo } = payload;

      store.dispatch(
        loginSuccess({
          token,
          service_access,
          userInfo,
        })
      );

      navigate('/', { replace: true });
    };

    window.addEventListener('message', handleMessage);

    if (window.opener) {
      window.opener.postMessage('ready', origin);
    }

    return () => window.removeEventListener('message', handleMessage);
  }, [navigate, origin]);

  return (
    <div className="flex items-center justify-center h-screen bg-black/25">
      <span className="loading loading-spinner loading-lg"></span>
    </div>
  );
}

export default LoginByRoot;
